<template>
  <div>
    <ContentTop>
      <img
        src="../assets/images/icon.png"
        alt=""
      />
      <span> 请选择系统查重</span>
    </ContentTop>
    <!-- <ARow>
      <ACol :span="18" offset="3">
        <Step/>
      </ACol>
    </ARow> -->
    <div class="step">
      <Step/>
    </div>
  </div>
</template>

<script>
import ContentTop from '@/components/ContentTop'
import Step from '@/components/Step'
// import { Row, Col } from 'ant-design-vue'
export default {
  components: {
    ContentTop,
    Step,
    // ARow: Row,
    // ACol: Col,
  },
  data () {
    return {
      clicked: 0,
      routes: [
        {
          path: 'one',
          breadcrumbName: '首页',
        },
        {
          path: 'down',
          breadcrumbName: '下载报告',
        },
        {
          path: 'second',
          breadcrumbName: '报告演示',
        },
        {
          path: 'four',
          breadcrumbName: '系统介绍',
        },
        {
          path: 'five',
          breadcrumbName: '常见问题',
        },
      ],
      //   current: ['index'],
    }
  },
}
</script>

<style lang="less" scoped>
.contentTop{
  background-color: rgb(34, 105, 190);
  padding: 0 10%;
}
.step{
  margin: 0 10%;
}
</style>